const defaultState = {
  param: {},
  order: {},
  couponInfo: {}
};

export default function loading(state=defaultState, action) {
  let stateCopy = {...state};
    switch(action.type) {
      // 接受上一页参数
        case 'orderPass':
          stateCopy.param = action.data
          break;
      // 修改参数
        case 'orderEdit':
          const param = Object.assign(state.param, action.data)
          stateCopy.param = param
          break;
      // 清空参数
        case 'orderClear':
          stateCopy.param = {}
          stateCopy.order = {}
          break;
      // 写入订单详情信息
        case 'orderInfo':
          stateCopy.order = action.data
          break
      // 写入优惠券信息
      case 'orderCouponAdd':
        stateCopy.couponInfo = action.data || {}
        break
      case 'orderCouponRemove':
        stateCopy.couponInfo = {}
        break
      default:
        return state;
    }
    return stateCopy;
}